import React, { Component } from 'react';
import './SearchBox.css'

export default class SearchBox extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {};
    // }
    handleSearchButton = () => {
        this.props.onSearch();
    }
    clearAll = () => {
        this.props.clearAll();
    }
    render() {
        return (
            <div className={this.props.name}>
                <span hidden={this.props.hiddenCount}>該当銘柄</span><span className="count" hidden={this.props.hiddenCount}>{this.props.data.count}</span><span hidden={this.props.hiddenCount}>件</span>
                <div className="searchbtn" onClick={this.handleSearchButton}>検索</div>
                {this.props.hvClean&&<div className="clearAll" onClick={this.clearAll}>全条件をクリア</div>
                }

            </div>
        );
    }
}